import React from 'react';
import './CloseButton.css';

/**
 * CloseButton - A unified button component for closing popups
 * 
 * @param {object} props
 * @param {function} props.onClick - Function to call when button is clicked
 * @param {string} props.variant - Optional variant ('default', 'outside', 'transparent')
 * @param {string} props.className - Optional additional CSS classes
 * @param {string} props.label - Optional label, defaults to '×'
 * @returns {JSX.Element}
 */
const CloseButton = ({ 
  onClick, 
  variant = 'default', 
  className = '', 
  label = 'x',
  ...rest 
}) => {
  let variantClass = '';
  
  if (variant === 'outside') {
    variantClass = 'outside';
  } else if (variant === 'transparent') {
    variantClass = 'transparent';
  }

  return (
    <button
      className={`close-button ${variantClass} ${className}`}
      onClick={onClick}
      aria-label="Close"
      type="button"
      {...rest}
    >
      {label}
    </button>
  );
};

export default CloseButton; 